export enum MaintenanceStrategyTabIndex {
  Overview = 0,
  Analysis = 1,
}
